import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-m-how',
    templateUrl: './m-how.component.html',
    styleUrls: ['./m-how.component.scss'],
    standalone: false
})
export class MHowComponent {
     companyInfo!: FormGroup;
     emailsTested: number = 0;
     pageReady:boolean = false;
     constructor(public generalService: GeneralService,
          public enrollmentService: EnrollmentService,
          private modalService: NgbModal, private _router:  Router) {
          
          //we are going to double test all the emails here.
          // if there is a problem we will move the customer back to review
          this.enrollmentService.foundDupEmails = false;
          const power = this.enrollmentService.testEmail(this.enrollmentService.powerUser!.email)
          .subscribe((v: any) => {
               if(v === 'true'){
                    this.generalService.pageLogging("M-How",null,"","Dup Email Power User:" + this.enrollmentService.powerUser!.email).subscribe();
                    this.enrollmentService.foundDupEmails = true;
                    this._router.navigateByUrl('/signup/14');
               }
               if(this.enrollmentService.billingUserSame === "false"){
                    this.enrollmentService.testEmail(this.enrollmentService.billingUser!.email).subscribe((v: any) => {
                         if(v === 'true'){
                              this.generalService.pageLogging("M-How",null,"","Dup Email Billing User:" + this.enrollmentService.billingUser!.email).subscribe();
                              this.enrollmentService.foundDupEmails  = true;
                              this._router.navigateByUrl('/signup/14');
                         }
                    });
               }
               if(this.enrollmentService.users!.length > 0){
                    this.emailsTested = 0
                    for(let i = 0; i < this.enrollmentService.users!.length; i++){

                         this.enrollmentService.testEmail(this.enrollmentService.users![i].email).subscribe((v: any) => {       
                              if(v === 'true'){
                                   this.generalService.pageLogging("M-How",null,"","Dup Email  User:" + this.enrollmentService.users![i].email).subscribe();;
                                   this.enrollmentService.foundDupEmails  = true;
                                   i = this.enrollmentService.users!.length;
                                   this._router.navigateByUrl('/signup/14');
                              }else{
                                   this.emailsTested++;
                                   if(this.emailsTested === this.enrollmentService.users!.length){
                                        this.pageReady = true;
                                   }
                              }
                         });
                    };    
               }else{
                    this.pageReady = true;
               }
          });
          
     }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ]
     }

     ngOnInit(): void {
          this.companyInfo = new FormGroup({
               discoveredViaOther: new FormControl(this.enrollmentService.discoveredViaOther, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z0-9 '\-\&amp;']*)$/)
               ])
          });
          setTimeout(() => this.scrollToTop(), 500);
     }

     get discoveredViaOther() { return this.companyInfo!.get('discoveredViaOther'); }

     pageValid() {
          if(this.pageReady){
               if(this.enrollmentService.newCustomer!.discoveredPspVia === 'Other') {
                    return !this.companyInfo.valid
               } else if (this.enrollmentService.newCustomer!.discoveredPspVia === ''){
                    return true;
               }
          }
          return false;
      }

      ngAfterViewInit() {
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }

     scrollToTop() {
          window.scrollTo(0, 0);
      }

     ngOnDestroy() {
          if(this.enrollmentService.newCustomer!.discoveredPspVia !== 'Other'){
               this.discoveredViaOther?.setValue('');
          }
          this.enrollmentService.discoveredViaOther = this.discoveredViaOther!.value;
          this.enrollmentService.saveToLocal();
     }

}
